import Typography from "@mui/material/Typography";
import React from "react";

export const FeedbackAlert = () => (
  <Typography sx={{ touchAction: "none" }} component="h6">
    Спасибо за ценный отзыв! <br /> Хорошего вам дня 😎
  </Typography>
);
